/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
/* eslint-disable */
import 'expose-loader?exposes=Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'jquery-touchswipe';
import './selectors';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import DropDown from './components/drop-down';
import Form from './components/form';
import usePasswordPolicy from './components/usePasswordPolicy';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';

import './components/block-cart';
import $ from 'jquery';
/* eslint-enable */

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

// POPUP
function popup(e) {
    let popup = $('#' + e.attr('data-popup'))

    if(!popup.hasClass('nobg')) {
        $('body').addClass('mode-popup')
    }
    popup.addClass('open')

    $(document).mouseup(function(e){
        if (!popup.is(e.target) && popup.has(e.target).length === 0)
        {
            popup.removeClass('open')
            $('body').removeClass('mode-popup')
        }
    });
}

$(document).ready(() => {
    const dropDownEl = $('.js-dropdown');
    const form = new Form();
    const topMenuEl = $('.js-top-menu ul[data-depth="0"]');
    const dropDown = new DropDown(dropDownEl);
    const topMenu = new TopMenu(topMenuEl);
    const productMinitature = new ProductMinitature();
    const productSelect = new ProductSelect();
    const id_page = $('body').attr('id');

    dropDown.init();
    form.init();
    topMenu.init();
    productMinitature.init();
    productSelect.init();
    usePasswordPolicy('.field-password-policy');

    $('.carousel[data-touch="true"]').swipe({
        swipe(event, direction) {
        if (direction === 'left') {
            $(this).carousel('next');
        }
        if (direction === 'right') {
            $(this).carousel('prev');
        }
        },
        allowPageScroll: 'vertical',
    });

    // TOGGLE SECTION
    $('.toggle-item').on('click', '> .toggle-launcher', function () {
        if ($(this).parent().hasClass('open')) {
            $(this).parent().removeClass('open')
        } else {
            $('.toggle-section .toggle-item.open').removeClass('open')
            $(this).parent().addClass('open')
        }

        return false
    })

    // BOUTON TOGGLE MAIN NAV
    $('.toggle-nav').on('click', function () {
        $(this).toggleClass('menu-open')
        $('.header-nav').toggleClass('showing-nav')
        $('body').toggleClass('no-scroll')
        return false
    })

    $('.close-nav').on('click', function () {
        $(this).removeClass('menu-open')
        $('.header-nav').removeClass('showing-nav')
        $('body').removeClass('no-scroll');
        return false
    })

    // RETOUR EN HAUT - créer balise #gotop
    $('#gotop').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
    })

    $('[data-popup]').on('click', function () {
        popup($(this))
    });

    // CLOSE POPUP
    $('.close-popup').on('click', function () {
        $('body').removeClass('mode-popup')
        $('body').removeClass('no-scroll')
        $(this).parent('.popup').removeClass('open')
    })

    $('[data-img]').on('click', function() {
        let img = $('#' + $(this).attr('data-img'))

        img.siblings().removeClass('show');
        img.addClass('show')
    })

    // FACET FILTERS
    $('body').on('click', '[data-facet]', function () {
        let facets = $('.facet-content');
        let facets_link = $('.facet-title');
        let facet = $('#' + $(this).attr('data-facet'))

        if($(this).hasClass('actif')) {
            facets_link.removeClass('actif');
            facets.removeClass('active');

        } else {

            facets_link.removeClass('actif');
            facets.removeClass('active');
            $(this).addClass('actif');
            facet.addClass('active');
        }

        return false
    })

    let lastScrollTop = 0;
    let posHeaderTop = $('.header-top').offset().top + $('.header-top').height();
    let isHeaderFixed = false; // État pour éviter les conflits

    // Fonction pour gérer le fixed header avec classes de transition
    function handleFixedHeader() {
        let currentScrollTop = $(window).scrollTop();

        // Si on a dépassé la position du header-top
        if (currentScrollTop > posHeaderTop) {
            $('.l-header').addClass('fixed-header');
            $('body').addClass('has-fixed-header');

            // Scroll vers le haut → Affiche le header (fixed + classe "show")
            /*if (currentScrollTop < lastScrollTop) {
                if (!isHeaderFixed) {
                    $('.header-main').addClass('header-show');
                    isHeaderFixed = true;
                }
            }
            // Scroll vers le bas → Masque le header (classe "hide")
            else if (currentScrollTop > lastScrollTop) {
                $('.header-main').removeClass('header-show');
                isHeaderFixed = false;
                // Retire "fixed-header" après la transition (optionnel, voir CSS)
            }*/
        } else {
            $('.l-header').removeClass('fixed-header header-show');
            //$('.header-main').removeClass('header-show');
            $('body').removeClass('has-fixed-header');
            isHeaderFixed = false;
        }

        lastScrollTop = currentScrollTop;
    }

    // Initialisation au chargement
    handleFixedHeader();

    // Écouteur d'événement scroll avec throttling (optimisation)
    $(window).on('scroll', function() {
        requestAnimationFrame(handleFixedHeader); // Évite les calculs inutiles
    });

    /*if(id_page == "category" || id_page == "cms") {
        let pos = $(window).scrollTop();
        let posHeader = 470;

        if(pos <= posHeader) {
            $('#gotop').removeClass('show');
        } else {
            $('#gotop').addClass('show');
        }

        $(window).on('scroll',function() {
            let pos = $(window).scrollTop();
            let posHeader = 470;

            if(pos <= posHeader) {
                $('#gotop').removeClass('show');
            } else {
                $('#gotop').addClass('show');
            }
        });
    }*/
});
